import React from 'react';
import CustomEventLeaderboardTable from './custom-event-leaderboard-table';
import CustomEventLeaderboardHeader from './custom-event-leaderboard-header';
import { CUSTOM_EVENT_LEADERBOARD_POINTS_BASED_SCORING_FORMAT_ID } from '../../../general/js/constants';

class CustomEventLeaderboardContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSortingAscending: true
        };
    }

    render() {
        const {
            scoringLeaderboard,
            scoringCourse,
            options
        } = this.props;

        const isPointsBased =
            scoringLeaderboard.scoringFormat ===
            CUSTOM_EVENT_LEADERBOARD_POINTS_BASED_SCORING_FORMAT_ID;

        return (
            <div>
                <CustomEventLeaderboardHeader
                    logo={options.customEventLeaderboardDatasource.logo}
                    patronLogo={options.customEventLeaderboardDatasource.patronLogo}
                ></CustomEventLeaderboardHeader>
                <CustomEventLeaderboardTable
                    options={options}
                    scoringCourse={scoringCourse}
                    currentRound={1}
                    players={scoringLeaderboard.players}
                    isPointsBased={isPointsBased}
                ></CustomEventLeaderboardTable>
            </div>
        );
    }
}

export default CustomEventLeaderboardContainer;
